import React from "react";
import PropTypes from "prop-types";
import { MdError, MdRefresh } from "react-icons/md";

const ErrorMessage = ({ 
  title = "Une erreur est survenue", 
  message, 
  onRetry, 
  showRetry = false,
  className = "" 
}) => {
  return (
    <div className={`text-center p-6 ${className}`}>
      <div className="flex justify-center mb-4">
        <MdError className="h-12 w-12 text-red-500" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      {message && (
        <p className="text-gray-600 mb-4">{message}</p>
      )}
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"
        >
          <MdRefresh className="h-4 w-4 mr-2" />
          Réessayer
        </button>
      )}
    </div>
  );
};

ErrorMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onRetry: PropTypes.func,
  showRetry: PropTypes.bool,
  className: PropTypes.string,
};

export default ErrorMessage;